import { render, staticRenderFns } from "./MultipleAreaSelected.vue?vue&type=template&id=8f6edfac"
import script from "./MultipleAreaSelected.vue?vue&type=script&lang=js"
export * from "./MultipleAreaSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports